import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { EditEmpresaService } from 'src/app/empresa/services/edit-empresa.service';
import { mensajeCertificadoDev } from '../assets/dataMensaje';
import { EmpresaHelperService } from '../../empresa/services/editar-empresa-helper.service';
import { RegistroService } from '../../registro.service';
import { CargaEmpresasService } from 'src/app/services/carga-empresas.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalDevolucionesComponent } from '../modal-devoluciones/modal-devoluciones.component';
import { EnviarCorreoService } from '../../services/envio-mensaje';

@Component({
    selector: 'app-report-devoluciones-page',
    templateUrl: './report-devoluciones-page.component.html',
    styleUrls: ['./report-devoluciones-page.component.css'],
})
export class LoadAndQueryDevPageComponent {
    years: number[] = [];
    semester: { value: number; name: string }[] = [
        { value: 1, name: 'Enero a Junio' },
        { value: 2, name: 'Julio a Diciembre' },
    ];
    reports: any[];
    selectedFile: File | undefined;

    filesend: boolean;
    fileUploaded: boolean;
    accessToken = '';

    selectedSemester: number;
    selectedYear: number;

    ultimoObjetoCreado;
    empresaSeleccionada;

    private apiUrl: string = environment.apiSiriUrl;
    @ViewChild('novedadIndividual', { static: false })
    modalDevoluciones: ModalDevolucionesComponent;
    @ViewChild('modalLoadReportDev') modalLoadReportDev: ElementRef;
    lastReportDev: any;
    showCertificados = false;

    showCertificates() {
        this.showCertificados = true;
    }
    constructor(
        private router: Router,
        private el: ElementRef,
        private modalService: NgbModal,
        private keycloakService: KeycloakService,
        private enviarCorreoService: EnviarCorreoService,
        private http: HttpClient,
        private editarService: EditEmpresaService,
        private registroService: RegistroService,
        private cargaEmpresasService: CargaEmpresasService,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    periodoHabilitado = false;
    periodoReemplazoHabilitado = false;
    //periodoActivo = false;
    fechaLimiteReemplazo: Date | null = null;

    async ngOnInit() {
        this.empresaSeleccionada = await firstValueFrom(
            this.cargaEmpresasService.obtenerEmpresaSeleccionada()
        );
        const currentYear = new Date().getFullYear();
        const currentSemester = new Date().getMonth();
        this.selectedYear = currentYear;
        const years = [];
        this.fileUploaded = false;

        if (currentSemester <= 5) {
            this.selectedSemester = 1; // Enero a Junio
        } else {
            this.selectedSemester = 2; // Julio a Diciembre
        }

        for (let i = currentYear; i >= currentYear - 10; i--) {
            years.push(i);
        }
        this.years = years;
        this.historyReportDev();
        this.keycloakService.getToken().then((token) => {
            this.accessToken = token;
        });
        const idReporteGuardado: any =
            this.registroService.listaReportesGuardados.find(
                (agenteVigilado) =>
                    agenteVigilado.idEmpresa ===
                    this.registroService.empresaSelected
            );
        this.ultimoObjetoCreado = idReporteGuardado;
        //await this.verificarPeriodo();
    }

    handleDownload() {
        if (this.periodoHabilitado || this.periodoReemplazoHabilitado) {
            this.downloadReport();
        }
    }

    handleUpload() {
        if (this.periodoHabilitado || this.periodoReemplazoHabilitado) {
            this.openMassUploadModal(this.modalLoadReportDev);
        }
    }

    /*async verificarPeriodo() {
        const hoy = new Date();
        const añoActual = hoy.getFullYear();
        const semestreActual = hoy.getMonth() <= 5 ? 1 : 2;
    
        const inicioPeriodo = new Date(añoActual, 6, 1);
        const finPeriodo = new Date(añoActual, 6, 30);
    
        this.periodoActivo = hoy >= inicioPeriodo && hoy <= finPeriodo;
        
        
        if (this.lastReportDev?.fechaRegistro) {
          const fechaRegistro = new Date(this.lastReportDev.fechaRegistro);
          this.fechaLimiteReemplazo = new Date(fechaRegistro);
          this.fechaLimiteReemplazo.setDate(fechaRegistro.getDate() + 10);
        }
      }
      calcularFechaLimiteReemplazo(fecha: string | Date): Date {
        const fechaLimite = new Date(fecha);
        fechaLimite.setDate(fechaLimite.getDate() + 10);
        return fechaLimite;
      }*/

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const allowedExtensions = /(\.xlsx)$/i;

            if (!allowedExtensions.exec(file.name)) {
                Swal.fire(
                    'Error con el archivo',
                    'Por favor, selecciona un archivo con extensión .xlsx',
                    'warning'
                );
                input.value = '';
            } else {
                this.selectedFile = file;
            }
        }
    }

    enviar() {
        this.modalDevoluciones.closeReport();
    }

    getFileSize(size: number): string {
        const fileSizeInKB = size / 1024;
        return fileSizeInKB.toFixed(2) + ' KB';
    }

    historyReportDev() {
        this.http
            .get(
                `${this.apiUrl}novedad/empresa-actual/${this.registroService.empresaSelected}/${this.selectedYear}/${this.selectedSemester}`
            )
            .subscribe(
                (response: any[]) => {
                    if (response && response.length > 0) {
                        response.sort(
                            (a, b) =>
                                new Date(b.fechaRegistro).getTime() -
                                new Date(a.fechaRegistro).getTime()
                        );
                        this.lastReportDev = response[0];
                        const semesterInfo = this.semester.find(
                            (s) => s.value === this.lastReportDev.semestre
                        );
                        this.lastReportDev.semestreNombre = semesterInfo
                            ? semesterInfo.name
                            : 'Semestre no definido';
                    } else {
                        // Inicializa lastReportDev con estructura básica
                        this.lastReportDev = {
                            name: '', // o cualquier propiedad que estés intentando acceder
                            fechaRegistro: null,
                            // otras propiedades necesarias
                        };
                    }
                    this.reports = response || [];
                },
                (error) => {
                    console.error('Error al descargar las novedades', error);
                    this.lastReportDev = {}; // Asegúrate de inicializar
                    this.reports = [];
                }
            );
    }

    async downloadReport() {
        /*if (!this.periodoHabilitado && !this.periodoReemplazoHabilitado) {
            Swal.fire('Período no habilitado', 'El período para descargar plantillas no está activo', 'warning');
            return;
          }*/
        try {
            console.log(
                `URL de descarga: ${this.apiUrl}novedad/descargar-novedades/${this.registroService.nitEmpresaSelected}`
            );

            const responseBlob = await lastValueFrom(
                this.http.get(
                    `${this.apiUrl}novedad/descargar-novedades/${this.registroService.nitEmpresaSelected}`,
                    { responseType: 'blob' }
                )
            );

            if (responseBlob) {
                saveAs(responseBlob, 'planilla-novedades-siriagro.xlsx');
            } else {
                console.error('No se recibió ningún archivo.');
            }
        } catch (error) {
            console.error('Error al descargar la plantilla:', error);
            alert('Hubo un error al intentar descargar la plantilla.');
        }
    }

    mostrarTexto() {
        this.translate
            .get('novedad.alertaAyuda')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    async descargarCertificado() {
        // Validar que exista la información de la novedad para generar certificado

        const fechaValida =
            this.lastReportDev.fechaRegistro != null &&
            this.lastReportDev.fechaRegistro !== '';

        if (!fechaValida) {
            console.warn('Datos incompletos:', {
                fechaRegistro: this.lastReportDev.fechaRegistro,
            });
            return;
        }
        const url = `${this.apiUrl}certificado`;
        try {
            const empresaActual =
                await this.editarService.getEmpresaActual('agente-vigilado');
            const mensaje = mensajeCertificadoDev(
                empresaActual,
                this.lastReportDev
            );

            const agenteVigilado = {
                mensaje: mensaje,
            };

            this.http
                .post(url, agenteVigilado, { responseType: 'blob' })
                .subscribe(
                    (blob: Blob) => {
                        saveAs(blob, 'certificado.pdf');
                    },
                    (error) => {
                        console.error(
                            'Error al descargar el certificado:',
                            error
                        );
                    }
                );
        } catch (error) {
            console.error(
                'Error al obtener la información de la empresa:',
                error
            );
        }
    }

    openMassUploadModal(content: any) {
        /*if (!this.periodoHabilitado && !this.periodoReemplazoHabilitado) {
            Swal.fire('Período no habilitado', 'El período para cargar novedades no está activo', 'warning');
            return;
          }*/

        this.filesend = false;
        this.fileUploaded = false;
        this.selectedFile = undefined;
        this.modalService.open(content);
    }

    saveMassUpload() {
        if (this.selectedFile) {
            const formData = new FormData();
            formData.append('file', this.selectedFile);
            formData.append('anio', this.selectedYear.toString());
            formData.append('semestre', this.selectedSemester.toString());

            this.http
                .post(
                    `${this.apiUrl}novedad/carga-masiva-novedades/${this.registroService.empresaSelected}/${this.registroService.nitEmpresaSelected}/${this.registroService.correoCorporativo}`,
                    formData
                )
                .subscribe({
                    next: (response: any) => {
                        console.log(' Archivo subido con éxito:', response);

                        if (response?.statusCode === 206) {
                            this.fileUploaded = true;
                            this.filesend = false;
                            Swal.fire(
                                'Existe ya una novedad para esta fecha',
                                '',
                                'warning'
                            );
                        } else {
                            this.fileUploaded = false;
                            this.filesend = true;
                            Swal.fire(
                                'Archivo subido con éxito',
                                '',
                                'success'
                            );
                            this.enviarCorreoService.enviarCorreoNovedad;
                        }
                        //this.verificarPeriodo();
                        this.historyReportDev();
                    },
                    error: (e) => {
                        console.error(' Error al subir el archivo:', e);
                        this.fileUploaded = false;
                        this.filesend = false;

                        if (e?.error?.statusCode === 412) {
                            Swal.fire(
                                e.error.error ||
                                    'Datos erróneos, revisa el archivo',
                                e.error.message || '',
                                'warning'
                            );
                            this.closeMassUploadModal();
                        } else if (
                            e?.error?.error &&
                            typeof e.error.error === 'string'
                        ) {
                            Swal.fire(
                                'Error al subir el archivo',
                                e.error.error,
                                'warning'
                            );
                        } else {
                            Swal.fire(
                                'Error al subir el archivo',
                                'Ha ocurrido un error inesperado',
                                'warning'
                            );
                        }

                        this.closeMassUploadModal();
                    },
                });
        }
    }

    replaceFile() {
        if (this.selectedFile) {
            const formData = new FormData();
            formData.append('file', this.selectedFile);
            formData.append('anio', this.selectedYear.toString());
            formData.append('semestre', this.selectedSemester.toString());
            this.http
                .post(
                    `${this.apiUrl}novedad/carga-masiva-novedades/${this.registroService.empresaSelected}/${this.registroService.nitEmpresaSelected}/${this.registroService.correoCorporativo}?overwrite=true`,
                    formData
                )
                .subscribe(
                    (response: any) => {
                        this.fileUploaded = false;
                        this.filesend = true;
                    },
                    (e) => {
                        this.fileUploaded = false;
                        console.log(
                            'Error al subir el archivo reemplazo  ',
                            e.error
                        );
                        if (e.error.statusCode == 412) {
                            console.log('status 412 ');
                            this.fileUploaded = false;
                            this.filesend = false;
                            Swal.fire(
                                e.error.error ||
                                    'Datos erróneos, revisa el archivo',
                                e.error.message,
                                'warning'
                            );
                            this.closeMassUploadModal();
                        } else if (typeof e.error.error === 'object') {
                            Swal.fire(
                                'Error al subir el archivo',
                                ' ',
                                'warning'
                            );
                        } else {
                            Swal.fire(
                                'Error al subir el archivo',
                                e.error.error,
                                'warning'
                            );
                        }
                        this.closeMassUploadModal();
                    }
                );
        }
    }

    closeMassUploadModal() {
        this.fileUploaded = false;
        this.historyReportDev();
        this.modalService.dismissAll();
    }
}
